import { useEffect } from "react";

// Reference-counted body scroll lock. Multiple overlays can be open at once
// (mobile menu, video modal) — without a shared counter, the first one to
// close would reset `overflow` and unlock the page while another still needs
// it locked. The original overflow value is captured on the first lock and
// restored only when the last lock is released.
let lockCount = 0;
let previousOverflow = "";

const lock = () => {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
};

const unlock = () => {
  if (typeof document === "undefined" || lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = previousOverflow;
  }
};

export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    lock();
    return unlock;
  }, [active]);
}
